import { useProfile } from '@hooks/api';
import useGetStatusLink from '@hooks/useGetStatusLink';
import useStartKyc from '@hooks/useStartKyc';
import {
    ArrowRightIcon,
    BaseIcon,
    ButtonLabel,
} from '@moreharvest/component-library';
import { ctaClick } from '@services/analytics';
import { AnalyticsCtaId } from 'mh-client';
import { useNavigate } from 'react-router';

const GetStartedCta = ({
    id,
    screenName,
}: {
    id?: string;
    screenName?: string;
}) => {
    const { data: profile } = useProfile();
    const navigate = useNavigate();
    const link = useGetStatusLink(profile?.accountStatus);
    const startKyc = useStartKyc();

    const handleClick = () => {
        if (screenName) {
            ctaClick({
                screen_name: screenName,
                cta_id: AnalyticsCtaId.getInstance().GET_STARTED,
            });
        }
        if (link) {
            navigate(link);
        } else {
            startKyc.mutate();
        }
    };

    return (
        <ButtonLabel
            size="small"
            variant="solid"
            fit
            type="button"
            id={id ?? 'topNav_CTA_getStarted'}
            onClick={handleClick}
        >
            Get Started
            <BaseIcon size="small">
                <ArrowRightIcon className="fill-base-black" />
            </BaseIcon>
        </ButtonLabel>
    );
};

export default GetStartedCta;
